
import { jwtDecode } from 'jwt-decode'
import { toast } from "react-toastify";

export const validateEmail = (email) => {
  const pattern =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return pattern.test(email);
};


export function getDataFromJwt(dataUniqueName) {
  const readFromLocalStorage = localStorage.getItem("jwtToken")
  let dataIntoArray = readFromLocalStorage?.split(' ')
  if (dataIntoArray?.[1]) {
    const token = dataIntoArray[1]
    const user = jwtDecode(token)
    if (user[dataUniqueName])
      return user[dataUniqueName]
    else
      return null
  }
  window.location.href = "/"
}

export function toastMaker(message, type) {
  let content = message ? message : "Something went wrong. Try again later"
  if (type === "info") {
    toast.info(content)
  } else if (type === "success" || type === "success") {
    toast.success(content)
  } else if (type === "warning") {
    toast.warning(content)
  } else if (type === "error") {
    toast.error(content)
  } else {
    toast(content)
  }
}

export function clearLocalStorage() {
  localStorage.clear();
  window.location.href = '/login'
}

export function replaceIdInUrl(string, replaceWith) {
  return string.replace(":id", replaceWith)
}

export const isUser = () => {
  let role = getDataFromJwt("role");
  if (role == 3 || role == 4) {
    return true;
  }
};

export const isAdmin = () => {
  let role = getDataFromJwt("role");
  if (role == 1) {
    return true;
  } else {
    return false
  }
};
export const isVolunteer = () => {
  let role = getDataFromJwt("role");
  if (role == 2) {
    return true;
  } else {
    return false
  }
};


export const formatPhoneNumber = (value) => {
  // Remove all non-digit characters
  const cleaned = value.replace(/\D/g, '');

  if (cleaned.length === 0) return ''; // If empty, return empty

  // Format based on length
  if (cleaned.length <= 3) {
    return `(${cleaned}`;
  } else if (cleaned.length <= 6) {
    return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3)}`;
  } else {
    return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6, 10)}`;
  }
};